import React, { ReactNode } from 'react';
import { VideosProvider } from './upload/VideosContext';
import { ROIProvider } from './ROIContext';
import { AnalysisProvider } from './analysis/AnalysisContext';

interface AppProviderProps {
    children: ReactNode;
    imageRef: React.RefObject<HTMLImageElement>;
}

export const AppProvider: React.FC<AppProviderProps> = ({ children, imageRef }) => {
    return (
        <VideosProvider>
            <ROIProvider>
                <AnalysisProvider imageRef={imageRef}>
                    {children}
                </AnalysisProvider>
            </ROIProvider>
        </VideosProvider>
    );
};
